export default "__VITE_ASSET__NPIWpb9a__";